import { render, staticRenderFns } from "./b3Step.vue?vue&type=template&id=16c61aee&scoped=true&"
import script from "./b3Step.vue?vue&type=script&lang=js&"
export * from "./b3Step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c61aee",
  null
  
)

export default component.exports